import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import TransactionsService from 'donor-elf-web/services/transactions-service';

export default class TransactionsEditSaveController extends Controller {
  @service declare router: RouterService;
  @service declare transactionsService: TransactionsService;

  get lineItemInfos() {
    return this.transactionsService.lineItemInfos;
  }

  @action
  handleSaved() {
    this.transactionsService.lineItemInfos = [];
  }

  @action
  handleInvalidLineItemInfos(invalidLineItemInfos: any[]) {
    this.transactionsService.lineItemInfos = invalidLineItemInfos;
    this.router.transitionTo('funds.fund.transactions.edit.enter', 'add');
  }
}
